import React, { FC } from 'react';
import { BASE_URL } from '../../../../config/environmentConfig';
import { ColorModule } from './ColorModule';
import { ScriptComponent } from '../ScriptComponent';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { parseJwt } from '../../../views/login/Login';
import { IAuthState } from '../../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../setup';

interface Props {
	mid?: string;
}

export const getWidgetScript = (mid, siteId, siteName = ''): string => (
	`
    <script>
    	// Site Name: ${siteName}

	var scriptId = 'UIWidget';
      	var scriptSrc = '${BASE_URL.UI_WIDGET_URL}';
        var MID = '${mid}';
        var siteId = '${siteId}';
    
        (function (w,d,s,o,f,js,fjs) {
          w['Widget']=o;w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };
          js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
          js.id = o; js.src = f; js.async = 1; fjs.parentNode.insertBefore(js, fjs);
        }(window, document, 'script', scriptId, scriptSrc));
        UIWidget('init', MID, siteId);
    </script>
`
);

export const UiWidget: FC<Props> = (props: Props): React.ReactElement => {
	// const { mid } = props;
	const { id } = useParams<{ id: string }>();
	const { t } = useTranslation();

	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const user = parseJwt(authUser.idToken);
	const mid = user?.['custom:mid'];

	return (
		<>
			<div className="card mb-10">
				<div className="d-md-flex justify-content-md-between">
					<div className="card-body w-md-50">
						<ScriptComponent
							title={t('UI_WIDGET.SCRIPT')}
							script={getWidgetScript(mid, id)}
						/>
					</div>
					<div className="card-body w-md-50">
						<div className="fw-bolder fs-4">
							{t('UI_WIDGET.TITLE')}
						</div>
						<div className="mt-5 fs-6">
							{t('UI_WIDGET.TEXT')}
						</div>
						<div className="text-danger mt-5 fw-bold fs-7">
							<a href={BASE_URL.UI_WIDGET_DOCS} target="_blank" rel="noreferrer">
								{t('UI_WIDGET.LINK_NAME')}
							</a>
						</div>
					</div>
				</div>
			</div>

			<ColorModule mid={mid}/>
		</>
	);
};
